import React from 'react';
import BaseIcon from './BaseIcon';

class ConnectSVG extends BaseIcon {
  render() {
    const { fillColor, height, width } = this.props;
    return (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width={width} height={height}>
        <path
          strokeLinejoin="round"
          fill="none"
          stroke={fillColor}
          strokeLinecap="round"
          strokeWidth="5"
          d="M15.5 2.5v10"
        />
        <path
          d="M5.5 9.5a10.94 10.94 0 00-3 7.69 12.7 12.7 0 0013 12.56c7.18 0 13-5.36 13-12.44a11.25 11.25 0 00-3-7.81"
          strokeMiterlimit="10"
          fill="none"
          stroke={fillColor}
          strokeLinecap="round"
          strokeWidth="5"
        />
      </svg>
    );
  }
}

export default ConnectSVG;
